// src/gtag.ts

// FIX: Declare gtag on the window interface to prevent TypeScript errors.
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Initialize GA if not already loaded
export const initGA = () => {
  if (!window.gtag) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-HTVP4H4HMR';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-HTVP4H4HMR', { send_page_view: false });
    `;
    document.head.appendChild(script2);
  }
};

// Track pageview manually (needed for SPA routing)
export const trackPageview = (url: string) => {
  if (window.gtag) {
    window.gtag('config', 'G-HTVP4H4HMR', { page_path: url });
  }
};

// Track custom events
export const trackEvent = ({
  action,
  category,
  label,
  value,
}: {
  action: string;
  category: string;
  label?: string;
  value?: number;
}) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};